/* Adapt existing can states to the home banner's contained planar half-turn.
   Native controls, flavour selection, commerce and text flips remain owners. */
(() => {
  const registered = new Map();
  const reduced = matchMedia('(prefers-reduced-motion:reduce)');
  const canImage = image => /flippd-(?:masala|orange|lemon|panna|kaapi)-(?:front|back)\.png/.test(image.getAttribute('src') || '');
  // One motion implementation for hero, flavour shelf and shared can controls.
  function animateCan(rotor, {start, angle, from = 0, stage}) {
    const end = `rotate(${angle}deg)`;
    if (reduced.matches) return;
    stage ||= rotor.parentElement;
    // Use the surrounding visual, rather than a can-sized button, to keep
    // the can inside its card at the widest point of the half-turn.
    for (let i = 0; i < 5 && stage?.parentElement; i++) {
      if (stage.clientWidth > rotor.clientWidth * 1.5) break;
      stage = stage.parentElement;
    }
    const scale = Math.min(1, Math.max(1, (stage?.clientWidth || rotor.clientWidth) - 24) / Math.hypot(rotor.clientWidth, rotor.clientHeight));
    const middle = 90;
    let frames = [{transform:start},{transform:`rotate(${middle}deg) scale(${scale})`},{transform:end}];

    rotor.animate(frames, {duration:700,easing:'cubic-bezier(.4,0,.2,1)'});
  }
  window.FlippdCanFlip = animateCan;
  function angleFor(rotor) {
    if (rotor.classList.contains('flippd-product-rotor')) return rotor.parentElement.classList.contains('is-flipped') ? 180 : 0;
    const match = rotor.style.transform.match(/rotate(?:X|Y|Z)?\(\s*(-?[\d.]+)deg\)/);
    return match ? Number(match[1]) : 0;
  }
  function update(rotor, initial = false) {
    const record = registered.get(rotor);
    if (!record) return;
    const angle = angleFor(rotor), changed = record.angle !== angle;
    const end = `rotate(${angle}deg)`;
    if (initial || changed) {
      const start = getComputedStyle(rotor).transform;
      rotor.getAnimations().forEach(animation => animation.cancel());
      record.angle = angle;
      rotor.style.transform = end;
      if (!initial && !reduced.matches && !rotor.closest('[data-flippd-static-can]')) {
        animateCan(rotor, {start,angle,from:record.previousAngle ?? 0});
      }
      record.previousAngle = angle;
    } else if (rotor.style.transform !== end) rotor.style.transform = end;
  }
  function scan() {
    document.querySelectorAll('.flippd img,.flippd-pdp img,.flippd-collection img,.flippd-about img').forEach(image => {
      if (!canImage(image)) return;
      const rotor = image.parentElement;
      if (rotor.classList.contains('flippd-can-rotor') || registered.has(rotor)) return;
      const images = [...rotor.children].filter(el => el.tagName === 'IMG');
      if (images.length !== 2 || !images.every(canImage)) return;
      registered.set(rotor, {angle:null,previousAngle:0});
      rotor.setAttribute('data-flippd-can-motion','');
      update(rotor,true);
      const observer = new MutationObserver(() => update(rotor));
      observer.observe(rotor,{attributes:true,attributeFilter:['style']});
      if (rotor.classList.contains('flippd-product-rotor')) observer.observe(rotor.parentElement,{attributes:true,attributeFilter:['class']});
    });
    registered.forEach((_,rotor) => {if(!rotor.isConnected)registered.delete(rotor);});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',scan,{once:true}); else scan();
  new MutationObserver(records => {if(records.some(r=>r.type==='childList' && [...r.addedNodes].some(n=>n.nodeType===1)))scan();}).observe(document.documentElement,{childList:true,subtree:true});
  document.addEventListener('shopify:section:load',scan);
})();
